import { General_Interface } from './General_Interface'

export interface KarshnasMasol_Interface {
  id:number,
  fname:string,
  lname:string,
  semat:string,
  dsc: string,

  type: number,
  sex: number,


  Email:Array<General_Interface>,
  Dakhli:Array<General_Interface>,
  Tel:Array<General_Interface>,

  mobile:String,
  jaygozinMiblie:String,
  majaziMobile:String,

  email_temp:String,
  dakhli_temp:String,
  tel_temp:String,
  del?:boolean,
  smsActive?:boolean
}

export function Empty_KarshnasMasol_Interface():KarshnasMasol_Interface{
  return{
    id:0,
    lname:'',
    fname:'',
    semat: '',

    type: 0,
    sex: 0,

    mobile:'',
    jaygozinMiblie:'',
    majaziMobile:'',

    dsc:'',
    email_temp:'-1',
    dakhli_temp:'-1',

    tel_temp:'-1',
    Dakhli:[],
    Email:[],
    Tel:[],

    del:false,
    smsActive:false,
  }
}
